module.exports = __webpack_public_path__ + "static/img/badge.2e80409c.png";